<template>
  <!-- v-if="hasBusinessAccess" -->
  <section>
    <NavText text="Business" class="pl-2" />

    <div v-for="(navItem, index) in navLink" :key="index" class="">
      <!-- no dropdown -->

      <section v-if="businessNav(navItem)">
        <NoDropdownNav :navItem="navItem" :getNavIcon="getNavIcon" />
      </section>

      <!-- dropdown -->
      <section v-if="businessNav(navItem)">
        <DropdownNav :navItem="navItem" :getNavIcon="getNavIcon" />
      </section>

      <!--  -->
    </div>
  </section>
</template>

<script>
//components

import NavText from "../Text/NavText.vue";
import DropdownNav from "@/components/UI/AutomatedSidebar/DropdownNav.vue";
import NoDropdownNav from "@/components/UI/AutomatedSidebar/NoDropdownNav.vue";

export default {
  name: "BusinessSidenavs",
  props: ["navLink", "getNavIcon", "modules"],
  components: {
    NavText,
    DropdownNav,
    NoDropdownNav,
  },

  computed: {
    hasBusinessAccess() {
      this.navLink.forEach((navItems) => {
        const nav = navItems?.name?.toLowerCase();
        console.log(nav);
        if (
          (nav === "tanks" && this.modules?.includes("tanks")) ||
          (nav === "depot" && this.modules?.includes("depot")) ||
          (nav === "program" && this.modules?.includes("program")) ||
          (nav === "concession" && this.modules?.includes("concession")) ||
          (nav === "dealer" && this.modules?.includes("dealer"))
        ) {
          return true;
        } else {
          false;
        }
      });
    },
  },
  methods: {
    //utilities
    businessNav(navItems) {
      const nav = navItems?.name?.toLowerCase();
      if (
        (nav === "depot" && this.modules?.includes("dealers")) ||
        (nav === "depot" && this.modules?.includes("depot")) ||
        (nav === "program" && this.modules?.includes("program")) ||
        (nav === "concession" && this.modules?.includes("concession")) ||
        (nav === "dealer" && this.modules?.includes("dealer"))
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style></style>
